import { cn } from '@/app/utils/cn';

export const baseGridClassName = cn(
  'grid grid-cols-2 gap-x-4 md:gap-x-6 lg:grid-cols-3'
);
export const hideLastItemInGridClassName = cn('hide-until-lg'); // To support iOS 16
export const rowGapClassName = cn('gap-y-6');
